import { render } from "./base-button.vue?vue&type=template&id=d4ea591a&ts=true"
import script from "./base-button.vue?vue&type=script&lang=ts"
export * from "./base-button.vue?vue&type=script&lang=ts"

import "./base-button.vue?vue&type=style&index=0&id=d4ea591a&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__